import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

const selectKeepInTouchPageDomain = (state: ApplicationRootState) => state.farmToTablePage || initialState;

const selectKeepInTouchPage = () => createSelector(selectKeepInTouchPageDomain, (substate) => substate);

export default selectKeepInTouchPage;
